import { AvailableToggleFeatures } from '@spacefill/shared/src/utils/FeatureToggling/availableToggleFeatures';

const WelcomePage = async () =>
    import('../../pages/home/WelcomePage').then((module) => ({
        Component: module.WelcomePage,
    }));

const getWelcomePageRoutes = (user, features) => {
    if (!features?.[AvailableToggleFeatures.welcome_page]) return [];

    return [
        {
            path: '/welcome-page/',
            lazy: WelcomePage,
        },
    ];
};

export { getWelcomePageRoutes };
